import { Link, useLocation, useHistory } from "react-router-dom";
import { tokenDecode } from "../../../utils/helper";
import { useState, useEffect } from "react";
import styles from "./Side_bar.module.css";
import { config } from "../../../utils/config";
import jwt_decode from "jwt-decode";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaidIcon from '@mui/icons-material/Paid';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import GroupIcon from '@mui/icons-material/Group';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import Navbar from "../navbar";
import { FaStore } from "react-icons/fa";
import GavelIcon from '@mui/icons-material/Gavel';

const { apiEndpoint } = config;

const Sidebar = () => {
  const decoded = tokenDecode();
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  const { data } = decoded || {};
  const userObj = Array.isArray(data?.user) ? data?.user[0] : (data?.user || {});
  const roleObj = Array.isArray(data?.role) ? data?.role[0] : (data?.role || {});
  // console.log("sdfghjklsdfghjksdfghjk1", data?.user[0]?.parent_id)
  const hasSellerId = userObj?.seller_id !== null && userObj?.seller_id !== undefined && userObj?.seller_id !== "";
  const hasParentId = userObj?.parent_id !== null && userObj?.parent_id !== undefined && userObj?.parent_id !== "";
  const effectiveSellerId = hasSellerId
    ? userObj?.seller_id
    : hasParentId
      ? userObj?.parent_id
      : (roleObj?.seller_id ?? data?.seller_data?.[0]?.seller_id ?? data?.seller?.seller_id);
  const rawSellerId = effectiveSellerId;
  // console.log("sdfghjklsdfghjksdfghjk", effectiveSellerId)
  const admincheck = data?.user[0]?.parent_id
  console.log("dfghj565675767", admincheck)


  const isSuperAdmin = Number(effectiveSellerId) === 1 || Number(userObj?.id) === 1 || String(admincheck) === "0"

  // Sellers Management is visible ONLY when parent_id is exactly "0" (the true root admin account).
  // Everyone else (parent_id "1" or anything else) never sees it, no matter their permissions.
  const isRootAdmin = String(userObj?.parent_id) === "0";
  const terms = userObj?.seller_id

  // console.table("sdsdsdsdsdsdsdsdsd223333", isRootAdmin, terms, gggg)

  const isRootSeller = !isSuperAdmin && Number(effectiveSellerId) === 0;

  const getInitialMenu = () => {
    if (currentPath === "/dashboard" || currentPath === "/") return "dashboard";
    if (
      currentPath.includes("catalog") ||
      currentPath.includes("product") ||
      currentPath.includes("brand") ||
      currentPath.includes("category") ||
      currentPath.includes("buyerfee") ||
      currentPath.includes("fee") ||
      currentPath.includes("ondc")
    ) {
      if (isSuperAdmin) return "category";

      if (
        currentPath.includes("newcategory") ||
        currentPath.includes("brand") ||
        currentPath.includes("producttype") ||
        currentPath.includes("buyerfee")
      ) {
        return "category";
      }
      return "catalog";
    }
    if (currentPath.includes("order") || currentPath.includes("return")) return "orders";
    if (currentPath.includes("transaction") || currentPath.includes("unsettled")) return "transaction";
    if (
      currentPath.includes("issue") ||
      currentPath.includes("ticket") ||
      currentPath.includes("grievance") ||
      currentPath.includes("igm")
    ) {
      return "igm";
    }
    if (
      currentPath.includes("warehouse") ||
      currentPath.includes("addwarehouse") ||
      currentPath.includes("sellerdetail")
    ) {
      return "warehouse";
    }
    if (
      currentPath.includes("user") ||
      currentPath.includes("role")
    ) {
      return "users";
    }
    if (currentPath.includes("seller")) return "sellers";
    if (currentPath.includes("term") || currentPath.includes("condition")) return "terms";
    return "dashboard";
  };

  const getP = (tab) => {
    if (isSuperAdmin) {
      return { read: true, write: true, update: true, delete: true };
    }
    if (Array.isArray(data?.permission)) {
      const permArray = typeof data.permission.flat === "function" ? data.permission.flat() : data.permission;
      const perm = permArray.find((p) => p?.tab_name === tab);
      if (!perm) return { read: false, write: false, update: false, delete: false };
      return {
        read: Boolean(perm.p_read),
        write: Boolean(perm.p_write),
        update: Boolean(perm.p_update),
        delete: Boolean(perm.p_delete),
      };
    }
    const permObj = data?.permission?.[tab];
    if (permObj) {
      return {
        read: Boolean(permObj.p_read ?? permObj.read ?? false),
        write: Boolean(permObj.p_write ?? permObj.write ?? false),
        update: Boolean(permObj.p_update ?? permObj.update ?? false),
        delete: Boolean(permObj.p_delete ?? permObj.delete ?? false),
      };
    }
    return { read: false, write: false, update: false, delete: false };
  };

  const category = getP("category");
  const order = getP("order");
  const product = getP("product");
  const role = getP("role");
  const seller = getP("seller");
  const tax = getP("tax");
  const user = getP("user");
  const igm = getP("igm");
  const transaction = getP("transaction");

  // Raw users/role access — reads directly from token, ignores isSuperAdmin override
  const rawUsersAccess = (() => {
    if (Array.isArray(data?.permission)) {
      const permArray = typeof data.permission.flat === "function" ? data.permission.flat() : data.permission;
      const userPerm = permArray.find((p) => p?.tab_name === "user");
      const rolePerm = permArray.find((p) => p?.tab_name === "role");
      const hasUserAccess = userPerm ? (Boolean(userPerm.p_read) || Boolean(userPerm.p_write)) : true;
      const hasRoleAccess = rolePerm ? (Boolean(rolePerm.p_read) || Boolean(rolePerm.p_write)) : true;
      return hasUserAccess || hasRoleAccess;
    }
    return true; // no permission array = actual superAdmin, allow all
  })();

  const [activeMenu, setActiveMenu] = useState(getInitialMenu());
  const [openMenu, setOpenMenu] = useState(
    ["dashboard", "terms", "warehouse"].includes(getInitialMenu()) ? null : getInitialMenu()
  );

  useEffect(() => {
    const menu = getInitialMenu();
    setActiveMenu(menu);
    if (menu === "dashboard" || menu === "terms" || menu === "warehouse") {
      setOpenMenu(null);
    } else {
      setOpenMenu(menu);
    }
  }, [currentPath]);

  const getFirstSubcategoryPath = (menuId) => {
    switch (menuId) {
      case "category":
        if (category?.write) return "/newcategory";
        if (category?.read) return "/producttype";
        if (isSuperAdmin) return "/productlist";
        return "/newcategory";
      case "catalog":
        if (product?.read) return "/instorecatalog";
        if (product?.write) return "/createproduct";
        return "/instorecatalog";
      case "orders":
        return (isSuperAdmin || (admincheck === "0")) ? "/orderlist" : "/customerorder";
      case "transaction":
        return "/unsettledtransactions";
      case "igm":
        return "/issues";
      case "users":
        if (role?.write) return "/roles";
        if (user?.write) return "/adduser";
        if (user?.read) return "/userlist";
        return "/userlist";
      case "sellers": {
        const rawSellerPerm = Array.isArray(data?.permission)
          ? data.permission.find((p) => p?.tab_name === "seller")
          : null;
        const canWriteSeller = rawSellerPerm ? Boolean(rawSellerPerm.p_write) : true;
        if (canWriteSeller) return "/addseller";
        return "/sellerlist";
      }
      case "terms":
        return "/termandconditions";
      default:
        return null;
    }
  };

  const handleMenuClick = (menuId) => {


    setActiveMenu(menuId);
    setOpenMenu(menuId);
    const firstPath = getFirstSubcategoryPath(menuId);
    if (menuId === "sellers" && firstPath === "/addseller") {
      try {
        sessionStorage.removeItem("add_seller_draft_data");
        window.dispatchEvent(new CustomEvent("reset_add_seller"));
      } catch (e) {
        console.error(e);
      }
    }
    if (firstPath && currentPath !== firstPath.toLowerCase()) {
      history.push(firstPath);
    }
  };

  const [sidebarShow, setsidebarShow] = useState(checkstatus());

  function checkstatus() {
    try {
      if (sessionStorage.getItem("is_activated") === "true" || sessionStorage.getItem("seller_approved") === "1" || sessionStorage.getItem("isSkipped") === "true") {
        return 1;
      }
      const token = sessionStorage.getItem("token");
      if (token) return 1;
      return 1;
    } catch {
      return 1;
    }
  }

  useEffect(() => {
    function handleResize() {
      const loc = window.location.href.split("/");
      if (window.innerWidth > 766) {
        if (loc[loc.length - 1] === "sidebar") {
          history.push("/dashboard");
        }
      }
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [history]);

  const isKycPage = currentPath.includes("sellerdetails_kyc");

  return (
    <>
      <div className={styles.sidebar_navbar}>
        <Navbar />
      </div>

      {sidebarShow === 1 ? (
        <ul className={`navbar-nav sidebar-dark accordion ${styles.side_bar}`} id="accordionSidebar">
          {isKycPage && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 999,
                cursor: "not-allowed",
                backgroundColor: "rgba(255, 255, 255, 0.55)",
                backdropFilter: "blur(1.5px)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                userSelect: "none",
              }}
              onClick={(e) => e.preventDefault()}
            >
              <i className="fas fa-lock" style={{ fontSize: "22px", color: "#F97316" }}></i>
              <span style={{ fontSize: "12px", fontWeight: 600, color: "#475569", textAlign: "center", padding: "0 16px" }}>
                Complete or Skip KYC to access navigation
              </span>
            </div>
          )}

          {/* Brand Header */}
          <Link to="/dashboard" className={styles.brandContainer} onClick={() => { setActiveMenu("dashboard"); setOpenMenu(null); }}>
            <div style={{
              width: "34px",
              height: "34px",
              borderRadius: "8px",
              backgroundColor: "#FFF7ED",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0
            }}>
              <FaStore style={{ color: "#C2410C", fontSize: "19px" }} />
            </div>
            <span className={styles.brandText}>DigiDukaan</span>
          </Link>

          {/* Dashboard */}
          <li className="nav-item">
            <Link
              to="/dashboard"
              className={activeMenu === "dashboard" ? styles.activeNavItem : styles.mainNavLink}
              onClick={() => { setActiveMenu("dashboard"); setOpenMenu(null); }}
            >
              <div className={styles.navItemLeft}>
                <DashboardCustomizeIcon />
                <span>Dashboard</span>
              </div>
              <i className={`fas fa-chevron-right ${styles.arrowIcon}`}></i>
            </Link>
          </li>

          {/* SuperAdmin Category & Brand */}
          {product?.read && isSuperAdmin && (category?.write || category?.read) && (
            <li className="nav-item">
              <div
                className={activeMenu === "category" ? styles.activeNavItem : styles.mainNavLink}
                onClick={() => handleMenuClick("category")}
              >
                <div className={styles.navItemLeft}>
                  <PendingActionsIcon />
                  <span>Category & Brand</span>
                </div>
                <i className={`fas ${openMenu === "category" ? "fa-chevron-down" : "fa-chevron-right"} ${styles.arrowIcon}`}></i>
              </div>

              {openMenu === "category" && (
                <div className={styles.submenuContainer}>
                  {(category?.write || category?.read) && (
                    <Link to="/newcategory" className={`${styles.subItemLink} ${currentPath === "/newcategory" ? styles.subItemActive : ""}`}>
                      Category
                    </Link>
                  )}
                  {(category?.write || category?.read) && (
                    <Link to="/brand" className={`${styles.subItemLink} ${currentPath === "/brand" ? styles.subItemActive : ""}`}>
                      Brand
                    </Link>
                  )}
                  {(category?.write || category?.read) && (
                    <Link to="/producttype" className={`${styles.subItemLink} ${currentPath === "/producttype" ? styles.subItemActive : ""}`}>
                      Product Type
                    </Link>
                  )}
                  {isSuperAdmin && (
                    <Link to="/productlist" className={`${styles.subItemLink} ${currentPath === "/productlist" ? styles.subItemActive : ""}`}>
                      Products
                    </Link>
                  )}
                  {(category?.write || category?.read) && (
                    <Link to="/buyerfee" className={`${styles.subItemLink} ${currentPath === "/buyerfee" ? styles.subItemActive : ""}`}>
                      Buyer Finder fee
                    </Link>
                  )}
                </div>
              )}
            </li>
          )}

          {/* Catalog (Standard Seller) */}
          {product?.read && !isSuperAdmin && (
            <li className="nav-item">
              <div
                className={activeMenu === "catalog" ? styles.activeNavItem : styles.mainNavLink}
                onClick={() => handleMenuClick("catalog")}
              >
                <div className={styles.navItemLeft}>
                  <ListAltIcon />
                  <span>Catalog</span>
                </div>
                <i className={`fas ${openMenu === "catalog" ? "fa-chevron-down" : "fa-chevron-right"} ${styles.arrowIcon}`}></i>
              </div>

              {openMenu === "catalog" && (
                <div className={styles.submenuContainer}>
                  {product.read && (
                    <Link to="/instorecatalog" className={`${styles.subItemLink} ${currentPath === "/instorecatalog" ? styles.subItemActive : ""}`}>
                      In-Store Products
                    </Link>
                  )}
                  {(product.write || product.read) && (
                    <Link to="/createproduct" className={`${styles.subItemLink} ${currentPath === "/createproduct" ? styles.subItemActive : ""}`}>
                      Create Product
                    </Link>
                  )}
                  {product.read && (
                    <Link to="/ondclistedproduct" className={`${styles.subItemLink} ${currentPath === "/ondclistedproduct" ? styles.subItemActive : ""}`}>
                      Products Sold
                    </Link>
                  )}
                </div>
              )}
            </li>
          )}

          {!isSuperAdmin && (category?.read || category?.write) && (
            <li className="nav-item">
              <div
                className={activeMenu === "category" ? styles.activeNavItem : styles.mainNavLink}
                onClick={() => handleMenuClick("category")}
              >
                <div className={styles.navItemLeft}>
                  <PendingActionsIcon />
                  <span>Category & Brand</span>
                </div>
                <i className={`fas ${openMenu === "category" ? "fa-chevron-down" : "fa-chevron-right"} ${styles.arrowIcon}`}></i>
              </div>

              {openMenu === "category" && (
                <div className={styles.submenuContainer}>
                  {(category?.write || category?.read) && (
                    <Link to="/newcategory" className={`${styles.subItemLink} ${currentPath === "/newcategory" ? styles.subItemActive : ""}`}>
                      Category
                    </Link>
                  )}
                  {(category?.write || category?.read) && (
                    <Link to="/brand" className={`${styles.subItemLink} ${currentPath === "/brand" ? styles.subItemActive : ""}`}>
                      Brand
                    </Link>
                  )}
                  {(category?.write || category?.read) && (
                    <Link to="/producttype" className={`${styles.subItemLink} ${currentPath === "/producttype" ? styles.subItemActive : ""}`}>
                      Product Type
                    </Link>
                  )}
                  {(category?.write || category?.read) && (
                    <Link to="/productlist" className={`${styles.subItemLink} ${currentPath === "/productlist" ? styles.subItemActive : ""}`}>
                      Products
                    </Link>
                  )}
                  {(category?.write || category?.read) && (
                    <Link to="/buyerfee" className={`${styles.subItemLink} ${currentPath === "/buyerfee" ? styles.subItemActive : ""}`}>
                      Buyer Finder fee
                    </Link>
                  )}

                </div>
              )}
            </li>
          )}

          {/* Orders */}
          {(order?.read || transaction?.read) && order?.read && (
            <li className="nav-item">
              <div
                className={activeMenu === "orders" ? styles.activeNavItem : styles.mainNavLink}
                onClick={() => handleMenuClick("orders")}
              >
                <div className={styles.navItemLeft}>
                  <ReceiptLongIcon />
                  <span>Orders</span>
                </div>
                <i className={`fas ${openMenu === "orders" ? "fa-chevron-down" : "fa-chevron-right"} ${styles.arrowIcon}`}></i>
              </div>

              {openMenu === "orders" && (
                <div className={styles.submenuContainer}>
                  {isSuperAdmin || (admincheck === "0") ? (
                    <>
                      <Link to="/orderlist" className={`${styles.subItemLink} ${currentPath === "/orderlist" ? styles.subItemActive : ""}`}>
                        Order List
                      </Link>
                      <Link to="/returnorders" className={`${styles.subItemLink} ${currentPath === "/returnorders" ? styles.subItemActive : ""}`}>
                        Return Orders List
                      </Link>
                    </>


                  ) : (
                    <>
                      <Link to="/customerorder" className={`${styles.subItemLink} ${currentPath === "/customerorder" ? styles.subItemActive : ""}`}>
                        Active Orders
                      </Link>
                      <Link to="/completeOrder" className={`${styles.subItemLink} ${currentPath === "/completeorder" ? styles.subItemActive : ""}`}>
                        Complete Orders
                      </Link>
                      <Link to="/cancelOrderlist" className={`${styles.subItemLink} ${currentPath === "/cancelorderlist" ? styles.subItemActive : ""}`}>
                        Cancelled Orders
                      </Link>
                      <Link to="/returnorders" className={`${styles.subItemLink} ${currentPath === "/returnorders" ? styles.subItemActive : ""}`}>
                        Return Orders List
                      </Link>
                    </>
                  )}
                </div>
              )}
            </li>
          )}

          {/* Transaction */}
          {transaction?.read && decoded?.data?.user?.[0]?.parent_id !== 519 && (
            <li className="nav-item">
              <div
                className={activeMenu === "transaction" ? styles.activeNavItem : styles.mainNavLink}
                onClick={() => handleMenuClick("transaction")}
              >
                <div className={styles.navItemLeft}>
                  <PaidIcon />
                  <span>Transaction</span>
                </div>
                <i className={`fas ${openMenu === "transaction" ? "fa-chevron-down" : "fa-chevron-right"} ${styles.arrowIcon}`}></i>
              </div>

              {openMenu === "transaction" && (
                <div className={styles.submenuContainer}>
                  <Link to="/unsettledtransactions" className={`${styles.subItemLink} ${currentPath === "/unsettledtransactions" ? styles.subItemActive : ""}`}>
                    Unsettled Transaction
                  </Link>
                  <Link to="/transaction" className={`${styles.subItemLink} ${currentPath === "/transaction" ? styles.subItemActive : ""}`}>
                    Settled Transaction
                  </Link>
                </div>
              )}
            </li>
          )}

          {/* IGM Portal */}
          {(igm?.read || igm?.write) && (
            <li className="nav-item">
              <div
                className={activeMenu === "igm" ? styles.activeNavItem : styles.mainNavLink}
                onClick={() => handleMenuClick("igm")}
              >
                <div className={styles.navItemLeft}>
                  <ContactSupportIcon />
                  <span>Ticket Portal</span>
                </div>
                <i className={`fas ${openMenu === "igm" ? "fa-chevron-down" : "fa-chevron-right"} ${styles.arrowIcon}`}></i>
              </div>

              {openMenu === "igm" && (
                <div className={styles.submenuContainer}>
                  <Link to="/issues" className={`${styles.subItemLink} ${currentPath === "/issues" ? styles.subItemActive : ""}`}>
                    Ticket
                  </Link>
                  <Link to="/ticketsupport" className={`${styles.subItemLink} ${currentPath === "/ticketsupport" ? styles.subItemActive : ""}`}>
                    Ticket Support
                  </Link>
                  {/* <Link to="/grievancesettings" className={`${styles.subItemLink} ${currentPath === "/grievancesettings" ? styles.subItemActive : ""}`}>
                    Grievance Support
                  </Link> */}
                </div>
              )}
            </li>
          )}

          {/* Users */}
          {(user?.read || user?.write || role?.write) && rawUsersAccess && (
            <li className="nav-item">
              <div
                className={activeMenu === "users" ? styles.activeNavItem : styles.mainNavLink}
                onClick={() => handleMenuClick("users")}
              >
                <div className={styles.navItemLeft}>
                  <SupervisedUserCircleIcon />
                  <span>Users</span>
                </div>
                <i className={`fas ${openMenu === "users" ? "fa-chevron-down" : "fa-chevron-right"} ${styles.arrowIcon}`}></i>
              </div>

              {openMenu === "users" && (
                <div className={styles.submenuContainer}>
                  {(role?.write || role?.read) && (
                    <Link to="/roles" className={`${styles.subItemLink} ${currentPath === "/roles" ? styles.subItemActive : ""}`}>
                      Roles
                    </Link>
                  )}
                  {(user?.write || user?.read) && (
                    <Link to="/adduser" className={`${styles.subItemLink} ${currentPath === "/adduser" ? styles.subItemActive : ""}`}>
                      Add User
                    </Link>
                  )}
                  {user?.read && (
                    <Link to="/userlist" className={`${styles.subItemLink} ${currentPath === "/userlist" ? styles.subItemActive : ""}`}>
                      User List
                    </Link>
                  )}
                </div>
              )}
            </li>
          )}

          {/* Sellers Management — visible ONLY when parent_id === "0" (true root admin), regardless of isSuperAdmin */}
          {isRootAdmin && (seller?.read || tax?.write || seller?.write) && (
            <li className="nav-item">
              <div
                className={activeMenu === "sellers" ? styles.activeNavItem : styles.mainNavLink}
                onClick={() => handleMenuClick("sellers")}
              >
                <div className={styles.navItemLeft}>
                  <GroupIcon />
                  <span>Sellers Management</span>
                </div>
                <i className={`fas ${openMenu === "sellers" ? "fa-chevron-down" : "fa-chevron-right"} ${styles.arrowIcon}`}></i>
              </div>

              {openMenu === "sellers" && (
                <div className={styles.submenuContainer}>
                  {seller?.write && (
                    <Link
                      to="/addseller"
                      className={`${styles.subItemLink} ${currentPath === "/addseller" ? styles.subItemActive : ""}`}
                      onClick={() => {
                        try {
                          sessionStorage.removeItem("add_seller_draft_data");
                          window.dispatchEvent(new CustomEvent("reset_add_seller"));
                        } catch (e) {
                          console.error(e);
                        }
                      }}
                    >
                      Add Seller
                    </Link>
                  )}
                  {seller?.read && (
                    <Link to="/sellerlist" className={`${styles.subItemLink} ${currentPath === "/sellerlist" ? styles.subItemActive : ""}`}>
                      Seller List
                    </Link>
                  )}
                </div>
              )}
            </li>
          )}

          {/* Terms & Conditions (Only for Admin) */}
          {terms === "1" && (
            <li className="nav-item">
              <Link
                to="/termandconditions"
                className={activeMenu === "terms" ? styles.activeNavItem : styles.mainNavLink}
                onClick={() => { setActiveMenu("terms"); setOpenMenu(null); }}
              >
                <div className={styles.navItemLeft}>
                  <GavelIcon />
                  <span>Terms & Conditions</span>
                </div>
                <i className={`fas fa-chevron-right ${styles.arrowIcon}`}></i>
              </Link>
            </li>
          )}
        </ul>
      ) : (
        <ul className={`navbar-nav sidebar-dark accordion ${styles.side_bar}`} id="accordionSidebar">
          {/* ── KYC lock overlay: disable all sidebar navigation ── */}
          {isKycPage && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 999,
                cursor: "not-allowed",
                backgroundColor: "rgba(255, 255, 255, 0.55)",
                backdropFilter: "blur(1.5px)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                userSelect: "none",
              }}
              onClick={(e) => e.preventDefault()}
            >
              <i className="fas fa-lock" style={{ fontSize: "22px", color: "#F97316" }}></i>
              <span style={{ fontSize: "12px", fontWeight: 600, color: "#475569", textAlign: "center", padding: "0 16px" }}>
                Complete or Skip KYC to access navigation
              </span>
            </div>
          )}

          <Link to="/dashboard" className={styles.brandContainer} onClick={() => { setActiveMenu("dashboard"); setOpenMenu(null); }}>
            <div style={{
              width: "34px",
              height: "34px",
              borderRadius: "8px",
              backgroundColor: "#FFF7ED",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0
            }}>
              <FaStore style={{ color: "#C2410C", fontSize: "19px" }} />
            </div>
            <span className={styles.brandText}>DigiDukaan</span>
          </Link>

          <li className="nav-item">
            <Link to="/dashboard" className={activeMenu === "dashboard" ? styles.activeNavItem : styles.mainNavLink} onClick={() => { setActiveMenu("dashboard"); setOpenMenu(null); }}>
              <div className={styles.navItemLeft}>
                <DashboardCustomizeIcon />
                <span>Dashboard</span>
              </div>
            </Link>
          </li>

          {product?.read && (
            <li className="nav-item">
              <Link to="/instorecatalog" className={activeMenu === "catalog" ? styles.activeNavItem : styles.mainNavLink}>
                <div className={styles.navItemLeft}>
                  <ListAltIcon />
                  <span>Catalog</span>
                </div>
              </Link>
            </li>
          )}

          {/* Category (collapsed sidebar, standard/root seller) */}
          {!isSuperAdmin && (category?.read || category?.write) && (
            <li className="nav-item">
              <Link to={category?.write ? "/newcategory" : "/producttype"} className={activeMenu === "category" ? styles.activeNavItem : styles.mainNavLink}>
                <div className={styles.navItemLeft}>
                  <PendingActionsIcon />
                  <span>Category</span>
                </div>
              </Link>
            </li>
          )}

          {order?.read && (
            <li className="nav-item">
              <Link to="/orderlist" className={activeMenu === "orders" ? styles.activeNavItem : styles.mainNavLink}>
                <div className={styles.navItemLeft}>
                  <ReceiptLongIcon />
                  <span>Orders</span>
                </div>
              </Link>
            </li>
          )}

          {(igm?.read || igm?.write) && (
            <li className="nav-item">
              <Link to="/issues" className={activeMenu === "igm" ? styles.activeNavItem : styles.mainNavLink}>
                <div className={styles.navItemLeft}>
                  <ContactSupportIcon />
                  <span>IGM Portal</span>
                </div>
              </Link>
            </li>
          )}

          {(user?.read || user?.write) && (
            <li className="nav-item">
              <Link to="/userlist" className={activeMenu === "users" ? styles.activeNavItem : styles.mainNavLink}>
                <div className={styles.navItemLeft}>
                  <SupervisedUserCircleIcon />
                  <span>Users</span>
                </div>
              </Link>
            </li>
          )}

          {/* Sellers (collapsed sidebar) — visible ONLY when parent_id === "0" */}
          {isRootAdmin && (seller?.read || tax?.write || seller?.write) && (
            <li className="nav-item">
              <Link to={seller?.write ? "/addseller" : "/sellerlist"} className={activeMenu === "sellers" ? styles.activeNavItem : styles.mainNavLink}>
                <div className={styles.navItemLeft}>
                  <GroupIcon />
                  <span>Sellers</span>
                </div>
              </Link>
            </li>
          )}
        </ul>
      )}
    </>
  );
};

export default Sidebar;
